import { Outlet, ScrollRestoration } from "react-router-dom";
import { SiteHeader } from "@/platform/layout/site-header";
import { SiteFooter } from "@/platform/layout/site-footer";
import { useTenant } from "@/platform/tenants/use-tenant";
import { PLATFORM_DEFAULT_ACCENT } from "@/platform/tenants/registry";

/**
 * RootLayout aplica a cor de accent do tenant ativo no escopo do <div>
 * raiz. Páginas dentro herdam via `var(--color-accent)`. Rotas
 * platform-level (sem tenant) usam o accent neutro Neuronix (violeta).
 *
 * Componentes que precisam de accent customizado para um tenant diferente
 * (ex.: LandingHub que mostra os dois lado a lado) ainda podem sobrescrever
 * localmente via style={{ '--color-accent': 'hsl(...)' }}.
 */
export function RootLayout() {
  const tenant = useTenant();
  const accent = tenant?.accent ?? PLATFORM_DEFAULT_ACCENT;

  const accentStyle = {
    "--color-accent": `hsl(${accent.hsl})`,
    "--color-accent-deep": `hsl(${accent.deepHsl})`,
    "--color-accent-soft": `hsl(${accent.softHsl})`,
  } as React.CSSProperties;

  return (
    <div className="flex min-h-dvh flex-col" style={accentStyle} data-tenant={tenant?.slug ?? "platform"}>
      <SiteHeader />
      <main className="flex-1">
        <Outlet />
      </main>
      <SiteFooter />
      <ScrollRestoration />
    </div>
  );
}
